import { createFileRoute } from '@tanstack/react-router';
import { parseSettingsSearch, type SettingsSearch } from '@/features/settings/settings-search';
import { SettingsPage } from '@/features/settings/settings-page';

export const Route = createFileRoute('/_app/settings')({
  // `w` is the warehouse the Depolar section has open, so browser back leaves
  // the detail view and returns to the list (W-31 §4)
  validateSearch: (s: Record<string, unknown>): SettingsSearch => parseSettingsSearch(s),
  component: function Settings() {
    const { s, w } = Route.useSearch();
    return <SettingsPage section={s ?? 'company'} warehouseId={w} />;
  },
});
